export const UNKNOWN_SIM_ERROR = 'Unknown gas simulation error'

// Covers native wraps plus the more expensive FewToken wrap paths when estimation is unavailable.
// TODO(UniswapX): add fallback gas limits per chain? l2s have higher costs
export const WRAP_FALLBACK_GAS_LIMIT_IN_GWEI = 250_000

export const FALLBACK_SWAP_REQUEST_POLL_INTERVAL_MS = 1000
